import { Card, Col, Container, Row } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll";
import img1 from "../assets/img/headhunting.png"
import img2 from "../assets/img/online-marketing.png"
import img3 from "../assets/img/schedule.png"

const Offer = () => {
    return(
        <Container className="service pt-5 pb-5 mt-5">
            <ScrollAnimation animateIn='bounce' animateOnce={true}>
                <div className="text-center"><strong className="text-brand">PENAWARAN KAMI</strong></div>
                <div className="header mt-4 text-black text-center">Industri dan Pekerjaan yang Kami Tawarkan</div>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                <Row className="mt-4">
                    <Col sm={12} md={4} lg={4} className="mb-3">
                        <Card className="h-100 shadow ps-3 pe-3 pt-3">
                            <Card.Body className="d-flex flex-column">
                                <img src={img1} alt="" width={"30%"}/>
                                <h5 className="mt-3 text-capitalize"><strong>Outsourcing Tenaga Kerja</strong></h5>
                                <div className="flex-grow-1">
                                    <ul>
                                        <li>SPG / SPB</li>
                                        <li>Merchandiser</li>
                                        <li>Team Leader / Project Leader</li>
                                        <li>Canvaser</li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={12} md={4} lg={4} className="mb-3">
                        <Card className="h-100 shadow ps-3 pe-3 pt-3">
                            <Card.Body className="d-flex flex-column">
                                <img src={img2} alt="" width={"30%"}/>
                                <h5 className="mt-3 text-capitalize"><strong>Layanan Aktivasi & Promosi</strong></h5>
                                <div className="flex-grow-1">
                                    <ul>
                                        <li>Direct Selling</li>
                                        <li>Canvasing</li>
                                        <li>Branding</li>
                                        <li>Branding</li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={12} md={4} lg={4} className="mb-3">
                        <Card className="h-100 shadow ps-3 pe-3 pt-3">
                            <Card.Body className="d-flex flex-column">
                                <img src={img3} alt="" width={"30%"}/>
                                <h5 className="mt-3 text-capitalize"><strong>Manajemen Event</strong></h5>
                                <div className="flex-grow-1">
                                    <ul>
                                        <li>Gathering</li>
                                        <li>Launching</li>
                                        <li>Exhibition</li>
                                        <li>Seminar</li>
                                        <li>Konser</li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </ScrollAnimation>
        </Container>
    )
}

export default Offer